// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundProjectionScreenOutlinedSvg from "@ant-design/icons-svg/es/asn/FundProjectionScreenOutlined";
import AntdIcon from '../components/AntdIcon';

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlinedSvg
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
export default React.forwardRef(FundProjectionScreenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FundProjectionScreenOutlined.js
// module id = 1239
// module chunks = 0